import { css } from 'lit';

var css_248z = css`::slotted(.stretched-link):before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:1}`;

export { css_248z as default };
//# sourceMappingURL=sgds-card2.js.map
